"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var PrepDetailsChangesEdit_1 = require("../../gen-src/icons/PrepDetailsChangesEdit");
var Localize_1 = require("../../gen-src/Localize");
var ColumnAndFieldDetailsStyles_1 = require("./style/ColumnAndFieldDetailsStyles");
exports.maxCharacterLength = 4000;
var InlineDescriptionTableCell = data_catalog_shared_1.divWithStyle('InlineDescriptionTableCell', {
    display: 'table-cell',
});
// Someday we will convert this entire thing to hooks, but until then we'll just inject dependencies using a hooked container component.
function InlineDescriptionEditor(props) {
    var apiRequests = React.useContext(data_catalog_shared_1.ApiRequestsContext);
    return React.createElement(InlineDescriptionEditorComponent, __assign({}, props, { apiRequests: apiRequests }));
}
exports.InlineDescriptionEditor = InlineDescriptionEditor;
var InlineDescriptionEditorComponent = /** @class */ (function (_super) {
    __extends(InlineDescriptionEditorComponent, _super);
    function InlineDescriptionEditorComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.localIsMounted = false;
        _this.enterEditMode = function () {
            if (_this.localIsMounted) {
                _this.setState({ isInEditMode: true });
            }
        };
        _this.handleBodyChange = function (event) {
            if (_this.localIsMounted) {
                _this.setState({ inputText: event.target.value });
            }
        };
        _this.handleSave = function () {
            if (_this.localIsMounted) {
                _this.setState({ isWaitingForSaveCallback: true });
                _this.props.onSave(_this.state.inputText)
                    .then(function () {
                    if (_this.localIsMounted) {
                        _this.setState({
                            isWaitingForSaveCallback: false,
                            isInEditMode: false,
                            currentText: _this.state.inputText
                        });
                    }
                    if (_this.props.afterSave) {
                        window.setTimeout(_this.props.afterSave, 2000);
                    }
                })
                    .catch(function () {
                    if (_this.localIsMounted) {
                        _this.setState({ isWaitingForSaveCallback: false, isInEditMode: false });
                    }
                });
            }
        };
        _this.handleCancelEdit = function () {
            if (_this.localIsMounted) {
                _this.setState({ inputText: _this.props.initialValue, isInEditMode: false });
            }
        };
        _this.state = {
            isInEditMode: false,
            isWaitingForSaveCallback: false,
            // Impose maximum length on input
            inputText: _this.props.initialValue.substring(0, exports.maxCharacterLength),
            currentText: props.initialValue
        };
        return _this;
    }
    InlineDescriptionEditorComponent.prototype.renderEditButton = function () {
        return (React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Icon, handleClick: this.enterEditMode, title: Localize_1.Messages.EditDescription(), testId: 'edit-description', getContent: function () { return React.createElement(PrepDetailsChangesEdit_1.SvgPrepDetailsChangesEdit, null); } }));
    };
    InlineDescriptionEditorComponent.prototype.renderSaveAndCancelButtons = function () {
        return (React.createElement(ColumnAndFieldDetailsStyles_1.SaveAndCancelButtonsWrapper, null,
            React.createElement(ColumnAndFieldDetailsStyles_1.SaveAndCancelButtonsFlexWrapper, null,
                React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Primary, handleClick: this.handleSave, title: Localize_1.Messages.Save(), testId: 'save-description', style: { marginBottom: widgets_1.TabStyles.Spacing.DefaultSpace }, disabled: this.state.isWaitingForSaveCallback }, Localize_1.Messages.Save()),
                React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, handleClick: this.handleCancelEdit, title: Localize_1.Messages.Cancel(), testId: 'cancel-description', disabled: this.state.isWaitingForSaveCallback }, Localize_1.Messages.Cancel()))));
    };
    InlineDescriptionEditorComponent.prototype.renderTextArea = function () {
        return (React.createElement(InlineDescriptionTableCell, null,
            React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsTextAreaWrapper, null,
                React.createElement("textarea", { value: this.state.inputText, className: 'inline-description-editor-text-area', onChange: this.handleBodyChange, style: ColumnAndFieldDetailsStyles_1.columnDetailsTextAreaStyle, disabled: this.state.isWaitingForSaveCallback, maxLength: exports.maxCharacterLength, "data-tb-test-id": 'description-text-area' }),
                this.renderSaveAndCancelButtons())));
    };
    InlineDescriptionEditorComponent.prototype.render = function () {
        return (React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsProperty, null,
            React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.Description()),
            this.state.isInEditMode ?
                this.renderTextArea() :
                React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsDescriptionValue, null,
                    React.createElement("div", { style: { maxHeight: ColumnAndFieldDetailsStyles_1.descriptionMaxHeight } }, this.state.currentText ? this.state.currentText :
                        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnDetailsPlaceholder, null, Localize_1.Messages.NoDescriptionAvailable()))),
            this.props.canEdit && !this.state.isInEditMode ? this.renderEditButton() : null));
    };
    InlineDescriptionEditorComponent.prototype.componentDidMount = function () {
        this.localIsMounted = true;
    };
    InlineDescriptionEditorComponent.prototype.componentWillUnmount = function () {
        this.localIsMounted = false;
    };
    return InlineDescriptionEditorComponent;
}(React.Component));
exports.InlineDescriptionEditorComponent = InlineDescriptionEditorComponent;
//# sourceMappingURL=InlineDescriptionEditor.js.map